import { AnimatePresence, motion } from "framer-motion";
import { PATHWAYS } from "@/data/pathways";
import { useAssessment } from "@/hooks/useAssessment";
import SEO from "@/components/SEO";
import CheckupIntro from "@/components/checkup/CheckupIntro";
import QuestionStep from "@/components/checkup/QuestionStep";
import ResultsStage from "@/components/checkup/ResultsStage";

const questionVariants = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1], staggerChildren: 0.06, delayChildren: 0.12 },
  },
  exit: { opacity: 0, x: -40, transition: { duration: 0.3, ease: "easeIn" } },
};

export default function Checkup({ pathwayKey = "complete" }) {
  const pathway = PATHWAYS[pathwayKey] || PATHWAYS.complete;
  const a = useAssessment(pathway);

  return (
    <div className="min-h-[80vh] bg-cream">
      <SEO title={pathway.seo.title} description={pathway.seo.description} path={pathway.route} />
      <div className="max-w-2xl mx-auto px-5 sm:px-6 py-8 md:py-14">
        <AnimatePresence mode="wait">
          {a.step === "intro" && <CheckupIntro key="intro" pathway={pathway} onStart={a.start} />}

          {typeof a.step === "number" && a.question && (
            <motion.div key={`q-${a.question.id}`} initial="hidden" animate="show" exit="exit" variants={questionVariants}>
              <QuestionStep
                pathway={pathway}
                question={a.question}
                answers={a.answers}
                step={a.step}
                total={a.visibleQuestions.length}
                progress={a.progress}
                isLast={a.isLast}
                onSelect={a.selectOption}
                onToggle={a.toggleMulti}
                onBack={a.back}
                onNext={a.next}
              />
            </motion.div>
          )}

          {a.step === "results" && (
            <motion.div key="results" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="print-area pt-2">
              <ResultsStage result={a.result} error={a.resultError} pathway={pathway} assessmentId={a.assessmentId} onRetry={a.finish} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
